import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./lista-atenciones.component.html")

AtencionesComponent.$inject = [
  "PlanAccionService",
  "TareaService",
  "TipoAlertaService",
  "CategoriaService"
]
function AtencionesComponent(PlanAccionService, TareaService, TipoAlertaService, CategoriaService) {
  var self = this

  self.$onInit = function() {}

  self.refreshAtencionesPlanesCallback = function() {
    if (self.refreshAtenciones === undefined) {
      self.refreshAtenciones = 0
    } else {
      self.refreshAtenciones += 1
    }

    if (self.refreshAtencionesPlan === undefined) {
      self.refreshAtencionesPlan = 0
    } else {
      refreshAtencionesPlan += 1
    }
  }

  self.refreshAtencionesCallback = function() {
    if (self.refreshAtenciones === undefined) {
      self.refreshAtenciones = 0
    } else {
      self.refreshAtenciones += 1
    }
  }

  self.modelName = "acciones"

  self._columns = [
    {
      key: "plan_accion",
      value: "plan de acción"
    },
    {
      key: "nombre",
      value: "nombre"
    },
    {
      key: "descripcion",
      value: "descripción"
    },
    {
      key: "categoria",
      value: "categoría"
    }
  ]

  self.menuOptions = [
    {
      name: "Editar",
      callback: "editRow",
      args: "editar"
    },
    {
      name: "Eliminar",
      callback: "deleteRow"
    }
  ]

  self.crudMenu = [
    {
      action: "crear",
      icon_name: "add",
      callback: "create"
    },
    {
      action: "editar",
      icon_name: "mode_edit",
      callback: "editModels"
    },
    {
      action: "eliminar",
      icon_name: "delete",
      callback: "delete"
    }
  ]

  self.onCreate = function(post_data) {
    return TareaService.save(post_data).$promise
  }

  self.onEdit = function(tarea) {
    return TareaService.update({ tarea: tarea.id }, tarea).$promise
  }

  self.onDelete = function(models) {
    return TareaService.remove({ "ids[]": models }).$promise
  }

  self._getModels = function() {
    return TareaService.get().$promise.then(function(data) {
      return data.results
    })
  }

  //############# Planes de Acción ############

  self.modelNamePlan = "planes_accion"

  self._columnsPlan = [
    {
      key: "nombre",
      value: "nombre"
    },
    {
      key: "descripcion",
      value: "descripción"
    },
    {
      key: "categoria",
      value: "categoría"
    }
  ]

  self.menuOptionsPlan = [
    {
      name: "Editar",
      callback: "editRow",
      args: "editar"
    },
    {
      name: "Eliminar",
      callback: "deleteRow"
    }
  ]

  self.crudMenuPlan = [
    {
      action: "crear",
      icon_name: "add",
      callback: "create"
    },
    {
      action: "editar",
      icon_name: "mode_edit",
      callback: "editModels"
    },
    {
      action: "eliminar",
      icon_name: "delete",
      callback: "delete"
    }
  ]

  self.onCreatePlan = function(post_data) {
    return PlanAccionService.save(post_data).$promise
  }

  self.onEditPlan = function(plan) {
    return PlanAccionService.update({ plan_accion: plan.id }, plan).$promise
  }

  self.onDeletePlan = function(models) {
    return PlanAccionService.remove({ "ids[]": models }).$promise
  }

  self._getModelsPlan = function() {
    return PlanAccionService.get().$promise.then(function(data) {
      return data.results
    })
  }

  //############# Categorías #############

  self.modelNameCategoria = "categorias"

  self._columnsCategoria = [
    {
      key: "nombre",
      value: "nombre"
    }
  ]

  self.menuOptionsCategoria = [
    {
      name: "Editar",
      callback: "editRow",
      args: "editar"
    },
    {
      name: "Eliminar",
      callback: "deleteRow"
    }
  ]

  self.crudMenuCategoria = [
    {
      action: "crear",
      icon_name: "add",
      callback: "create"
    },
    {
      action: "editar",
      icon_name: "mode_edit",
      callback: "editModels"
    },
    {
      action: "eliminar",
      icon_name: "delete",
      callback: "delete"
    }
  ]

  self.onCreateCategoria = function(post_data) {
    return CategoriaService.save(post_data).$promise
  }

  self.onEditCategoria = function(categoria) {
    return CategoriaService.update({ id: categoria.id }, categoria).$promise
  }

  self.onDeleteCategoria = function(models) {
    return CategoriaService.remove({ "ids[]": models }).$promise
  }

  self._getModelsCategoria = function() {
    return CategoriaService.get().$promise.then(function(data) {
      return data.results
    })
  }

  //############# Tipos Alertas #############

  self.modelNameTipoAlertas = "tipoAlertas"

  self._columnsTipoAlertas = [
    {
      key: "nombre",
      value: "nombre"
    }
  ]

  self.menuOptionsTipoAlertas = [
    {
      name: "Editar",
      callback: "editRow",
      args: "editar"
    },
    {
      name: "Eliminar",
      callback: "deleteRow"
    }
  ]

  self.crudMenuTipoAlertas = [
    {
      action: "crear",
      icon_name: "add",
      callback: "create"
    },
    {
      action: "editar",
      icon_name: "mode_edit",
      callback: "editModels"
    },
    {
      action: "eliminar",
      icon_name: "delete",
      callback: "delete"
    }
  ]

  self.onCreateTipoAlertas = function(post_data) {
    return TipoAlertaService.save(post_data).$promise
  }

  self.onEditTipoAlertas = function(tipo_alerta) {
    return TipoAlertaService.update({ id: tipo_alerta.id }, tipo_alerta).$promise
  }

  self.onDeleteTipoAlertas = function(models) {
    return TipoAlertaService.remove({ "ids[]": models }).$promise
  }

  self._getModelsTipoAlertas = function() {
    return TipoAlertaService.get().$promise.then(function(data) {
      return data.results
    })
  }
}

angular.module("appModule").component("listaAtenciones", {
  templateUrl: templateUrl,
  bindings: {},
  controller: AtencionesComponent
})
